import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SettingsSections from '../basic/SettingsSections';
import { Loader } from "../../../../common/elements";
import { getPreferredNetwork } from '../../../../../actions/account/account';

class BasicSettingsPage extends Component {
    componentDidMount() {
        const { account, setAccount, getPreferredNetwork } = this.props;
        const personId = localStorage.getItem('person_id');
        if (!account) {
            setAccount(personId);
        }
        getPreferredNetwork(personId);
    };

    render() {
        const { account, passwordUpdated, preferred_network, history } = this.props;
        const personId = localStorage.getItem('person_id');
        if (!account) return <Loader />;

        return (
            <div>
                <main>
                    <SettingsSections history={history}
                        account={account}
                        personId={personId}
                        preferredNetwork={preferred_network ? preferred_network : null}
                        passwordUpdated={passwordUpdated}
                    />
                </main>
            </div>
        );
    };
}

BasicSettingsPage.propTypes = {
    account: PropTypes.object,
    passwordUpdated: PropTypes.object,
    getPreferredNetwork: PropTypes.func,
    setAccount: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        account: state.account.account,
        passwordUpdated: state.account.password_updated,
        preferred_network: state.account.preferred_network,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getPreferredNetwork: personId => dispatch(getPreferredNetwork(personId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BasicSettingsPage);


// WEBPACK FOOTER //
// src/client/components/site/features/account/basic/BasicSettingsPage.js